import { BaseService } from '@/modules/Core/services/BaseService' // Asegúrate de tener la interfaz definida
import type { IAudiLogs } from '@/modules/Administracion/interfaces'
export class LogService extends BaseService<IAudiLogs> {
  constructor () {
    super({
      baseUrl: 'system/logs/'
    })
  }
}
